<template><section><h3>面向渔场预测的海洋锋面智能分析系统</h3>
<h4>背景介绍：</h4>
<p>海洋锋面是不同性质水团交汇形成的强梯度区域，其位置、强度、冷暖侧结构及持续时间与海洋环境、物质输运、渔业资源和海上作业密切相关。锋面附近水体交换活跃、饵料生物丰富，往往是重要渔场的形成区域，锋面信息对渔业生产和海上作业具有直接的指导价值。
合作单位已经具备自1982年以来的锋面识别结果，部分数据中已包含：</p>
<ul>
<li>锋面位置与几何形态；</li>
<li>锋面冷侧和暖侧；</li>
<li>表层水温；</li>
<li>不同时间尺度的历史记录；</li>
<li>0.25°、0.1°以及更高分辨率数据；</li>
<li>可能用于业务下发的锋面预报结果。
然而，现有数据体量大、文件分散、时间跨度长，使用者通常需要先寻找数据文件、裁剪空间区域、匹配时间、调用统计程序，再手工组织图表。对于一个具体问题，例如“8月5日某个位置附近是否容易出现锋面”，现有工作流程仍然较为复杂。
本项目拟设计一个任务驱动的海洋锋面交互式分析系统。用户给出日期、位置、范围和分析目标，系统自动提取相关数据，呈现当前锋面、冷暖侧和表层水温，并进一步关联1982年以来的历史信息，计算锋面发生概率、持续性及其他统计特征，为渔业作业提供锋面背景信息。</li>
</ul>
<p>数据：<a href="https://zenodo.org/records/20356239">zenodo数据链接</a></p>
<h4>项目要求：</h4>
<ol>
<li>
<p>支持局地海洋数据自动提取</p>
<ul>
<li>用户输入日期、经纬度和空间范围后，系统自动定位相应数据文件，并裁剪目标区域。例如：查询8月5日东经124.5°、北纬30.2°附近1°×1°区域的海表温度和锋面。</li>
</ul>
</li>
<li>
<p>呈现锋面的空间结构，系统应在地图中显示：</p>
<ul>
<li>海表温度；锋面线；</li>
<li>锋面冷侧和暖侧；</li>
<li>用户查询点；</li>
<li>分析区域；</li>
<li>查询点到最近锋面的距离；</li>
<li>查询点所在的冷暖侧；</li>
<li>局地温度梯度。</li>
</ul>
</li>
<li>
<p>支持历史锋面统计。基于1982年以来的数据，计算：</p>
<ul>
<li>历史同期锋面发生概率；</li>
<li>月度锋面发生频率；</li>
<li>多年平均值；</li>
<li>最小值和最大值；</li>
<li>参与统计的年份；</li>
<li>不同年份间的差异。
系统不仅给出“5%”这一结果，还需要说明：</li>
<li>统计的空间范围；</li>
<li>统计的时间窗口；</li>
<li>有效年份数量；</li>
<li>锋面事件判定规则；</li>
<li>具体计算过程。</li>
</ul>
</li>
<li>
<p>支持锋面事件分析。在后续阶段，系统可以围绕单一锋面分析：</p>
<ul>
<li>锋面的出现和消失；</li>
<li>连续多日的位置变化；</li>
<li>移动方向和速度；</li>
<li>强度变化；</li>
<li>分裂与合并；</li>
<li>锋面持续时间；</li>
<li>与涡旋或其他海洋过程的关系。</li>
</ul>
</li>
<li>
<p>引入离线AI辅助分析。本地大语言模型主要承担：</p>
<ul>
<li>理解用户自然语言任务；</li>
<li>将问题转换为结构化分析参数；</li>
<li>自动选择和组合分析工具；</li>
<li>总结已经计算出的统计结果；</li>
<li>引导用户开展下一步分析。
所有概率、温度、距离、梯度和预测结果均由确定性程序或专业模型计算，大语言模型不直接生成数值结果。</li>
</ul>
</li>
<li>
<p>支持渔场预测。第二阶段起，系统接入往年渔业数据（如渔获量统计、作业记录等），将锋面特征（位置、距离、冷暖侧、历史发生概率等）与渔业数据在时间和空间上匹配，结合锋面情况与往年同期的渔业记录，给出查询位置和日期的渔场预测参考，并展示预测依据，为渔业作业安排提供辅助。</p>
</li>
</ol>
</section></template><script>export default {components:{}}</script>